export default __webpack_public_path__ + "static/media/icon-batch-84x82.b07c7d7c.svg";